/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import $ from 'jquery';
import React, { Component } from 'react';
import Iframe from 'react-iframe';

/**
 *
 * ChatSupport component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class ChatSupport extends Component {
  public showChatBox = (): void => {
    $('.chat-popup').css('display', 'block');
  };

  public hideChatBox = (): void => {
    $('.chat-popup').css('display', 'none');
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <button className='open-button' onClick={this.showChatBox}>
          Need Help?
        </button>
        <div className='chat-popup'>
          <button
            className='btn btn-sm btn-danger closeChatButton'
            onClick={this.hideChatBox}
          >
            x
          </button>
          <Iframe
            url='https://powerva.microsoft.com/webchat/bots/a9a1f4c2-892a-4963-b6a8-cd940e722fd1'
            width='100%'
            height='100%'
            frameBorder={0}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default ChatSupport;
